/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, {
      params: {
        q,
      },
    });
  }

  contacts({ q, signal }) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        q,
      },
      signal,
    });
  }

  conversations({ q, signal }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        q,
      },
      signal,
    });
  }

  messages({ q, signal }) {
    return axios.get(`${this.url}/messages`, {
      params: {
        q,
      },
      signal,
    });
  }
}

export default new SearchAPI();
